type AppendScriptProps = {
    url: string;
    id: string;
    async?: boolean;
};

async function appendScript({ url, id, async = false }: AppendScriptProps): Promise<HTMLScriptElement> {
    return new Promise((resolve, reject) => {
        const scriptElement = document.getElementById(id);
        if (scriptElement) {
            resolve(scriptElement as HTMLScriptElement);
            return;
        }

        const script = document.createElement('script');
        script.id = id || '';
        script.src = url;
        script.async = async;
        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Script load error for ${url}`));

        document.body.appendChild(script);
    });
}

export default appendScript;
